import { ConnectionCreatorScenarioCategory } from "types/enums";
import { z } from "zod";

export const schema = z.object({
    title: z.string().min(1, "forms.general-validation.title_required"),
    is_enabled: z.boolean(),
    form_structure_ids: z.array(z.string()).optional(),
    category: z
        .nativeEnum(ConnectionCreatorScenarioCategory)
        .nullable()
        .refine((v) => v !== null, "forms.general-validation.required"),
});

export type AddFormStructureScenarioFormData = z.infer<typeof schema>;
